export const cacheKeys = {
  getUser: 'getUser',
  getUsers: 'getUsers',
  getInvite: 'getInvite',
  createUser: 'createUser',
  editUser: 'editUser',
  deleteUser: 'deleteUser',
  inviteUser: 'inviteUser',
};
